// Usage:
// Sei fn eine Funktion, die/das eine Liste von primitiven als Parameter erhält. 
// Dann cached eine Instanz von FunctionValueCache(fn) die Ergebnisse dieser Funktion.
// 
// Usage:
// let pc = new FunctionValueCache(fetch)
// /* Ruft die Seite ab */
// x = await pc.get("http://www.google.de");
// /* Ruft die Seite nicht mehr ab, sondern liefert das Ergebnis aus xdem Cache
// y = await pc.get("http://www.google.de");
//
// Es geht mitmehr als einem Parameter:
// const plus = (a,b) => a+b;
// let pc = new PromiseCache(plus)
// x = pc.get(1,2);
// y = pc.get(1,2); // plus wird nicht mehr aufgerufen
//
// Erzeuge einen neuen Cache-Eintrag
function newCacheEntry() {
 return {
    argValues: new Map()  // Map, die ein Argument auf die nächsten CacheEntry abbildet
  }
}

/**
 * @template A
 */
export default class FunctionValueCache{
  
  constructor(fn) {
    /**
     * @type {() => A}
     */
    this.fn = fn;
    // Cache. Für die Argumente "x1","y3",26 ist der Cache-Entry
    // this.root.get("x1").get("y3").get(26)
    this.root = newCacheEntry();
  }
  
  /**
   * 
   * @returns {A}
   */
  get() {
    let entry = this.root;
    // Entlang der Argumente im Cache-Baum hinabsteigen.
    // Auf dem Weg dahin die erforderlichen Maps anlegen
    for (let i=0; i < arguments.length;i++) {
        let child = entry.argValues.get(arguments[i]);
        if (child === undefined) {
            entry.argValues.set(arguments[i],child = newCacheEntry())
        }
        entry = child;
    }
    // Wurde für diesen Entry schon einmal ein Wert abgerufen?
    if (entry.value === undefined) {
      entry.value = this.fn.apply(null,arguments);
    }
    return entry.value;    
  }
}
